/** Telegram bot operational issues. */
import type { IssueDefinition } from "../issue-definition";
import { ISSUE_CATEGORY, ISSUE_FAULT } from "../issue-enums";

export const TELEGRAM_ISSUES = {
  TELEGRAM_BOT_TOKEN_INVALID: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Telegram bot token is invalid or revoked",
    severity: "critical",
    fault: ISSUE_FAULT.USER_ACTION,
    userTitle: "Telegram connection invalid",
    userGuidance:
      "Your Telegram bot token is invalid or was revoked, so the bot can't send or receive messages. Reconnect Telegram with a valid token."
  },
  TELEGRAM_CHAT_NOT_FOUND: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Telegram chat or user ID not found",
    // Medium: one chat Telegram no longer knows. The bot and every other chat still work, no
    // operator or customer lever revives it, and it pages nobody — the rank of its siblings in
    // `one-dead-conversation.registry.test.ts`.
    severity: "medium",
    // Reported per chat on a failed send, and nothing retries a chat that does not exist. A week
    // without another failed send to it means nobody is trying to reach it any more.
    resolvesAfterQuietHours: 168,
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "Telegram chat not found",
    userGuidance:
      "A Telegram chat or user reference no longer exists, so that conversation can't be reached."
  },
  TELEGRAM_BOT_BLOCKED_BY_USER: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "User has blocked the Telegram bot",
    severity: "medium",
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "User blocked the Telegram bot",
    userGuidance:
      "A user has blocked the bot on Telegram, so messages to that person can't be delivered. Only they can unblock it."
  },
  TELEGRAM_MESSAGE_RATE_LIMIT: {
    category: ISSUE_CATEGORY.PROVIDER,
    message: "Telegram API rate limit exceeded",
    severity: "medium",
    fault: ISSUE_FAULT.PROVIDER,
    userTitle: "Telegram rate limit reached",
    userGuidance:
      "Telegram is rate-limiting requests. Delivery catches up on its own once the limit clears."
  }
} as const satisfies Record<string, IssueDefinition>;
